import React, { useEffect, useState } from "react";
import { FiHome } from "react-icons/fi";
import { Link } from "react-router-dom";
import { useParams, useLocation } from "react-router";
import axios from "axios";
import $ from "jquery";
import HeaderSearchBar from "../components/headerSearchBar";

import "../css/libraries.css";

export default function Libraries() {

    var QRCode = require('qrcode.react');

    let { libraryid, bookid } = useParams();

    const [ libraryName, setLibName ] = useState("");
    const [ bookName, setBookName ] = useState("");
    const [ readedPages, setPages ] = useState("");
    const [ qrLink, setQR ] = useState("");

    function useQuery() {
        return new URLSearchParams(useLocation().search);
    }

    let query = useQuery();
    var queryBook = query.get("book");

    if( queryBook ) {
        axios.get(`https://www.googleapis.com/books/v1/volumes/${queryBook}`).then(resp => {

            axios.get(`https://cloudify-backend.herokuapp.com/libraries/details/${libraryid}`)
            .then(respp => {
                var books = respp.data.library.books;
                var data = resp.data;
                var volumeInfo = data.volumeInfo;

                books.forEach(book => {
                    document.getElementById("editingBookImage").src = volumeInfo.imageLinks.thumbnail;
                    setBookName(volumeInfo.title);
                    document.getElementById("pageCountingInput").placeholder = `O livro tem ${volumeInfo.pageCount} páginas`
                    document.documentElement.style.setProperty('--my-end-width', `${book.percentageOfReading}%`);
                })
            })
        })
    }

    useEffect(() => {
        axios.get(`https://cloudify-backend.herokuapp.com/libraries/details/${libraryid}`).then(resp => {
            var data = resp.data.library;

            if(data.books) {
                data.books.forEach(book => {

                    axios.get(`https://www.googleapis.com/books/v1/volumes/${book.bookId}`)
                    .then(resp => {
                        var volumeInfo = resp.data.volumeInfo;
                        $("#booksHolder").append(`  <div id="booksHolder"> <a href="/libraries/${libraryid}?book=${book.bookId}"> <div id="centered"> <h2>Você já leu ${book.percentageOfReading}%</h2> </div> <div id="generatedBookDisplayer"> <img src="${volumeInfo.imageLinks.thumbnail}" /> </div> </a> </div> `)
                    })
                })
            }

            setLibName(data.libraryName);
        })

        setQR(`/community/libraries/${libraryid}`);
    }, []);

    function submitReadedPages(event) {
        event.preventDefault();

        axios.get(`https://cloudify-backend.herokuapp.com/libraries/books/updatereading/${libraryid}/${queryBook}/${readedPages}`)
        .then(resp => {
            console.log(resp.data);
        })
    }

    function changeLibName() {
        axios.get(`https://cloudify-backend.herokuapp.com/libraries/changename/${libraryid}/${libraryName}`)
        .then(resp => {
            if(resp.data.sucesso == true) return window.location.reload();
            else return window.location.reload();
        })
    }

    return (

        <div>
            <HeaderSearchBar />

            <div className="centered">
            <div id="libraryHolder">
                    <Link to="/" > <FiHome style={{"color":"white", "fontSize":"32px"}} /> </Link>

                    <div className="centered">
                        <form onSubmit={changeLibName}>
                            <input id="libraryTitle" onChange={(key) => { setLibName(key.target.value) }} value={libraryName} />
                        </form>
                    </div>

                    <div className="centered">
                        <div id="editReadingStatuses">
                            <div id="editBookStatusDisplayer">
                                <img id="editingBookImage" />

                                <div id="infoDisplayer">
                                    <h1>{bookName}</h1>

                                    <div className="centered">
                                        <h1 id="pageReadingTitle">Já li até a página</h1>
                                    </div>

                                    <div className="centered">
                                        <div id="pageCounting">
                                            <form onSubmit={submitReadedPages} > <input id="pageCountingInput" onChange={(key) => { setPages(key.target.value) }} value={readedPages} /> </form>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="centered">
                                <div className="progress" id="progressBar">
                                    <div className="progress-value" id="progessBarLoading"></div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="centered">
                        <div id="booksHolder" />
                    </div>

                    <div className="centered">
                        <div id="shareDiv">
                            <QRCode value={window.location.href} id="qrcode" size="300" />

                            <div id="qrTextDiv">
                                <h1>Compartilhe sua biblioteca</h1>
                                <h2>Mostre ao mundo os seus livros, incentive a leitura</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}